import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import "./CurrencyRatesBar.scss";

const FX_ORDER = [
  { key: "USD", pillClass: "hr-currency-rates__pill--usd" },
  { key: "EUR", pillClass: "hr-currency-rates__pill--eur" },
  { key: "GBP", pillClass: "hr-currency-rates__pill--gbp" },
];

export function formatFxRateDisplay(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return null;
  return n.toFixed(4);
}

/**
 * אחידות עיצוב שערי מטבע (דולר / יורו / פאונד) בכל האתר.
 * @param {object} props
 * @param {{ USD?: number, EUR?: number, GBP?: number } | null | undefined} props.currencyRate
 * @param {boolean} [props.compact] — סרגל עליון / מקומות צרים
 * @param {'default' | 'menu'} [props.variant] — menu = תפריט המבורגר (רוחב מלא, עטיפה)
 * @param {string} [props.className]
 */
const CurrencyRatesBar = ({
  currencyRate,
  compact = false,
  variant = "default",
  className = "",
}) => {
  const { t } = useTranslation();

  const items = useMemo(() => {
    if (!currencyRate) return [];
    return FX_ORDER.map(({ key, pillClass }) => {
      const raw = currencyRate[key];
      const formatted = formatFxRateDisplay(raw);
      if (!formatted) return null;
      let labelKey;
      if (key === "USD") labelKey = "navbar.usdrate";
      else if (key === "EUR") labelKey = "navbar.eurrate";
      else labelKey = "navbar.gbprate";
      return {
        key,
        pillClass,
        label: t(labelKey),
        formatted,
      };
    }).filter(Boolean);
  }, [currencyRate, t]);

  if (!items.length) return null;

  const rootClass = [
    "hr-currency-rates",
    compact && "hr-currency-rates--compact",
    variant === "menu" && "hr-currency-rates--menu",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={rootClass} dir="rtl" role="group" aria-label={t("navbar.ratesgroup")}>
      <div className="hr-currency-rates__track">
        {items.map((item, index) => (
          <React.Fragment key={item.key}>
            {index > 0 ? (
              <span className="hr-currency-rates__divider" aria-hidden />
            ) : null}
            <span className={`hr-currency-rates__pill ${item.pillClass}`}>
              {item.label}: {item.formatted}
            </span>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default CurrencyRatesBar;
